import { CfStripProps } from "../types";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { convertCfBackgroundForGatsbyImageProps } from "utilities/cfPropTypes/cfBackground";
import { convertCfSpacersProps } from "utilities/cfPropTypes/cfSpacers";
import { convertCfWrapContentProps } from "utilities/cfPropTypes/cfWrapContent";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import React from "react";
import Strip from "../index";

export const convertCfStripProps = ({
  customClass,
  curvedBottom,
  slug,
  stripStyle,
  children,
  contentful_id,
}: CfStripProps) => {
  const liveInspector: LiveInspectorData = {
    stripItem: ContentfulLivePreview.getProps({
      entryId: contentful_id,
      fieldId: "entryTitle",
    }),
  };

  return {
    slug: slug || "",
    customClass: customClass || "",
    curvedBottom: curvedBottom || false,
    htmlTag: "section",
    children,
    hasPaddingWrapMobile: stripStyle?.hasPaddingWrapMobile ?? false,
    liveInspector,
    ...(stripStyle?.background &&
      convertCfBackgroundForGatsbyImageProps({
        ...stripStyle.background,
        customClass: curvedBottom ? "curved--bottom" : "",
      })),
    ...convertCfSpacersProps(stripStyle?.spacers),
    ...convertCfWrapContentProps(stripStyle?.wrapContent),
  };
};

const CfStrip = ({ children, ...props }: CfStripProps) => {
  const liveProps = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  return (
    <Strip
      {...convertCfStripProps({
        ...liveProps,
        children,
      })}
    />
  );
};

export default CfStrip;
